export class Candidato {
    constructor(
        public id?: number,
        public nome?: string,
        public imagem?: string,
        public curriculum?: string,
        public cpf?: string,
        public votos?: any,
        public cargo?: any,
        public votoJustificavel?: boolean,
        public parametroJustificativa?: string,
        public justificativa?: string,
        public selecionado?:boolean
    ) {

    }
}

